import styles from './PlanSelection.module.scss';
import { AppContext } from '../../context/AppContext';
import { useContext, useEffect, useState } from 'react';
import { IAppContext } from '../../context/DefaultAppState';
import DefaultButton from '../../components/DefaultButton/DefaultButton';
import { useHistory } from 'react-router-dom';
import * as _ from 'lodash';

const PlanSelectionPage = () => {
  const appContext = useContext(AppContext);
  const history = useHistory();

  // 🔹 Default year = 2026
  const [selectedYear, setSelectedYear] = useState(appContext.selectedYear || '2026');
  const [selectedStateText, setSelectedStateText] = useState('');
  const [selectedPlanText, setSelectedPlanText] = useState('');

  // 🔹 Filter plans based on selected year
  const filteredPlans = appContext.plansData.filter(
    plan => plan.reportYear?.includes(selectedYear)
  );

  // 🔹 Extract unique states from filtered plans
  const states = _.uniqBy(filteredPlans, 'state').map(p => p.state);

  // 🔹 Get plans only for the selected state
  const relevantPlans = filteredPlans.filter(p => p.state === selectedStateText);

  // 🔹 Navigation helper
  const handleContinue = () => {
    const path = window.location.href.split('/#/')[1];
    if (path) {
      history.push('/');
      history.push(`/${path}`);
    } else {
      history.push('/');
    }
  };

  // 🔹 Auto-select state if only one is available
  useEffect(() => {
    const numberOfStates = _.uniqBy(filteredPlans, 'state').length;
    if (numberOfStates === 1) {
      const singleState = states[0];
      appContext.updatePlanState(singleState);
      setSelectedStateText(singleState);
    }
  }, [filteredPlans, appContext, selectedYear, states]);

  return (
    <>
      {/* 🔹 Step 1: Select Year */}
       <div>
        <h3>Please Select a Year...</h3>
        <DefaultButton
          buttonText="2026"
          customClick={() => {
            setSelectedYear('2026');
            appContext.updateSelectedYear('2026');
            setSelectedStateText('');
            setSelectedPlanText('');
          }}
          selectedText={selectedYear}
        />
        <DefaultButton
          buttonText="2027"
          customClick={() => {
            setSelectedYear('2027');
            appContext.updateSelectedYear('2027');
            setSelectedStateText('');
            setSelectedPlanText('');
          }}
          selectedText={selectedYear}
        />
        {/* <DefaultButton
          buttonText="2027"
          customClick={() => {
            setSelectedYear('2027');
            appContext.updateSelectedYear('2027');
            setSelectedStateText('');
            setSelectedPlanText('');
          }}
          selectedText={selectedYear}
        /> */}
      </div> 

      {/* 🔹 Step 2: Select State */}
      {selectedYear && (
        <div>
          <h3>Please Select a State...</h3>
          {states.length > 0 ? (
            states.map(state => (
              <DefaultButton
                key={state}
                buttonText={state}
                customClick={() => {
                  appContext.updatePlanState(state);
                  setSelectedStateText(state);
                  setSelectedPlanText('');
                }}
                selectedText={selectedStateText}
              />
            ))
          ) : (
            <p>No states available for {selectedYear}</p>
          )}
        </div>
      )}

      {/* 🔹 Step 3: Select Plan */}
      {selectedStateText && (
        <div>
          <h3 style={{ marginTop: '1em' }}>Please Select a Plan...</h3>
          {relevantPlans.length > 0 ? (
            relevantPlans.map(plan => (
              <DefaultButton
                key={plan.planName}
                buttonText={plan.planName}
                customClick={() => setSelectedPlanText(plan.planName)}
                selectedText={selectedPlanText}
              />
            ))
          ) : (
            <p>No plans found for this state in {selectedYear}</p>
          )}
        </div>
      )}

      {/* 🔹 Step 4: Continue */}
      <DefaultButton
      buttonText="Continue to Formulary"
      customClick={() => {
        const selectedPlan = relevantPlans.find(
          p => p.planName === selectedPlanText
        );

        if (!selectedPlan) return;

        console.log('Selected formulary plan', {
          id: selectedPlan.id,
          planName: selectedPlan.planName,
          reportYear: selectedPlan.reportYear,
          formularyTier: selectedPlan.formularyTier,
          selectedYear,
        });

        appContext.updatePlanState(selectedStateText);
        appContext.updateSelectedYear(selectedYear);
        appContext.updatePlan(selectedPlan);

        handleContinue();
      }}
      selectedText=""
      shouldDisable={!selectedStateText || !selectedPlanText}
    />
    </>
  );
};



export default PlanSelectionPage;
 